module.exports = __webpack_public_path__ + "img/truck-semi.59086918.svg";